import React from 'react';
import PropTypes from 'prop-types';

const OptionalProduct = ({

  sku,
  name,
  //  content,
  description,
  image,
  type,
  cost,
  duration,
  clicked,
  onClick,
  perPerson,
  percent,
  width,
}) => {
  let styles = { };

  let wrongStyle = { };

  wrongStyle.width = width + '%';

  if (clicked) {
    styles = { borderColor: 'rgb(25, 97, 172)' };
  }

    styles.width = '100%';


    return (
  /*
  <li key={sku}>
    <h1>{name}</h1>
    <img src={image} alt={name} />
    <div>{description}</div>
    <div>{type}</div>
    <button
      onClick={onClick}
    >
      Choose this
    </button>
  </li>
  */
    <div className="flexStart" onClick={onClick} style={wrongStyle}>
      <div className="productBorder flexObject growBox" style={styles}>
        <h4 >{name}</h4>
        <p className="grow">{description !== '' ? description : '' }</p>

        {image !== '' && (
        <img src={image} width="100%" alt={description} />

    )}

        <div className="row displayPrices">

          <div className="col-xs-12"><span className="cost">{cost} SEK</span>  {perPerson === 'yes' && ('per deltagare')}
          </div>


        </div>
      </div>

    </div>


  );
};

/*
  content
  description
  image
  name
  sku
  type
*/
OptionalProduct.defaultProps = {
  duration: undefined,
};

OptionalProduct.propTypes = {
  name: PropTypes.string.isRequired,
  // content: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  sku: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  duration: PropTypes.string,


  //
  onClick: PropTypes.func.isRequired,
};

export default OptionalProduct;



// WEBPACK FOOTER //
// ./src/components/Resource/components/OptionalProduct.jsx